import React, { Component, Fragment } from 'react'
import './style.css'

import PostSidebar from './components/PostSidebar'
import PostCard from './components/PostCard'

import { connect } from 'react-redux'
import { Grid, Col, Row, Pagination } from 'react-bootstrap'

import { getResourcePosts, getTags } from './reducers/manageResourcePosts'
import AuthenticationComponent from '../../AuthenticationComponent';

class ResourcePostContainer extends Component {

  componentDidMount() {
    this.getResourcePostsWithFilters()
    this.props.getTags()
  }

  componentDidUpdate(prevProps) {
    if (this.props.userFilter.length !== prevProps.userFilter.length || this.props.tagFilter.length !== prevProps.tagFilter.length || this.props.sort !== prevProps.sort || (this.props.searchTerm.length === 0 && prevProps.searchTerm.length > 0)) {
      this.getResourcePostsWithFilters()
    }
  }

  getResourcePostsWithFilters = (page = 1) => {
    let filters, created_by, tags, search_term

    if (this.props.userFilter.length) {
      created_by = this.props.userFilter.map(user => user.user_id)
    }

    if (this.props.tagFilter.length) {
      tags = this.props.tagFilter.map(tag => tag.id)
    }

    if (this.props.searchTerm) {
      search_term = this.props.searchTerm
    }

    if (created_by || tags || search_term) {
      filters = {
          created_by,
          tags,
          search_term
        }
    }

     this.props.getResourcePosts(page, filters, this.props.sort)
  }

  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.getResourcePostsWithFilters()
    }
  }


  render () {
    let numberOfPages
    if (this.props.posts.length > 0) {
      numberOfPages = Math.ceil(this.props.postCount / this.props.postsPerPage)
    }

    let buttons = []

    for (let i = 0; i < numberOfPages; i++) {
      buttons.push(
        <Pagination.Item
          active={this.props.currentPage === i + 1}
          key={i}
          onClick={() => this.getResourcePostsWithFilters(i + 1)}
          >{i + 1}
        </Pagination.Item>
      )
    }

    // THIS ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE FIRST PAGE AND BACK ONE PAGE
    // IN THE PAGINATED POST RESULTS
    let firstButtons = [
      <Pagination.First
        key={'pagination-first'}
        onClick={() => this.getResourcePostsWithFilters(1)}
        disabled={this.props.currentPage === 1 ? true : false}
        />,
      <Pagination.Prev
        key={'pagination-back'}
        disabled={this.props.currentPage === 1 ? true : false}
        onClick={() => this.props.currentPage === 1 ? null: this.getResourcePostsWithFilters(this.props.currentPage - 1)}
        />
    ]

    // THIS ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE LAST PAGE AND FORWARD ONE PAGE
    // IN THE PAGINATED POST RESULTS
    let lastButtons = [
      <Pagination.Next
        key={'pagination-next'}
        disabled={this.props.currentPage === numberOfPages ? true : false}
        onClick={() => this.props.currentPage === numberOfPages ? null: this.getResourcePostsWithFilters(this.props.currentPage + 1)}
      />,
      <Pagination.Last
        key={'pagination-last'}
        disabled={this.props.currentPage === numberOfPages ? true : false}
        onClick={() => this.getResourcePostsWithFilters(numberOfPages)}
      />
    ]

    let currentPage = this.props.currentPage
    let lastPaginationPage = 5

    if (currentPage > 5) {
      let remainder = currentPage % 5
      lastPaginationPage = (currentPage - remainder) + 5
      currentPage = lastPaginationPage - 5
    } else {
      currentPage = 0
    }

    let displayButtons = [...firstButtons, ...buttons.slice(currentPage, lastPaginationPage), ...lastButtons]

    return (
      <div id="ResourcePostContainer">
        <AuthenticationComponent />
        <Grid>
          <Row>
            <Col xs={12} md={3}>
              <PostSidebar handleEnterPress={this.handleEnterPress}/>
            </Col>
            {this.props.fetchingResourcePosts || this.props.fetchingTags ?
              <Col xs={12} md={9}>
                <div id="not-found">
                  <img alt="loader" src={require("../../static/images/spinner.gif")} />
                </div>
              </Col>
              :
              <Fragment>
                <Col xs={12} md={9}>
                  {buttons.length > 1 ?
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <center>
                        <Pagination>
                          {displayButtons}
                        </Pagination>
                      </center>
                    </Col>
                    :
                    null
                  }

                  {this.props.posts.length > 0 ?
                    this.props.posts.map(post => <PostCard key={post.id} post={post} />)
                    :
                    <div id="not-found">
                      <br/>
                      No resource posts to display
                    </div>
                  }


                  {buttons.length > 1 ?
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <center>
                        <Pagination>
                          {displayButtons}
                        </Pagination>
                      </center>
                    </Col>
                    :
                    null
                  }
                </Col>
              </Fragment>
              }
            </Row>
          </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingResourcePosts: state.manageResourcePosts.fetchingResourcePosts,
    fetchingTags: state.manageResourcePosts.fetchingTags,
    posts: state.manageResourcePosts.posts,
    tags: state.manageResourcePosts.tags,
    currentPage: state.manageResourcePosts.currentPage,
    postsPerPage: state.manageResourcePosts.postsPerPage,
    postCount: state.manageResourcePosts.postCount,
    searchTerm: state.manageResourcePosts.searchTerm,
    userFilter: state.manageResourcePosts.userFilter,
    tagFilter: state.manageResourcePosts.tagFilter,
    sort: state.manageResourcePosts.sort,
  }
}

export default connect(mapStateToProps, { getResourcePosts, getTags })(ResourcePostContainer);



// WEBPACK FOOTER //
// ./src/routes/resource-posts/ResourcePostContainer.js